module.exports = __webpack_public_path__ + "img/2.41f3c5ab.svg";